import React, { useEffect, useState, useRef } from 'react';
import homeApi from '@/common/api';
import DFImage from '@/components/dFImage';
import rightIcon from '../imgs/right_arrow.png';
import styles from './index.less';
import { gioClick } from '@/utils/gioApi';
import { setDataGioList, checkExposureGio, clearGioStatus } from './gioUtils';
const AudioAndVideo = (props) => {
    const { audioInfo } = props;
    const [list, setList] = useState<any>([]);
    const [moreUrl, setMoreUrl] = useState<any>('');
    const [firstLoad, setFirstLoad] = useState<boolean>(true);
    const sliderRef = useRef(null);
    const dataList = useRef(audioInfo?.memberGroupList);
    useEffect(() => {
        setList(audioInfo?.memberGroupList);
        if(audioInfo?.moreUrl) {
            gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '直充会员', elementname: '更多会员', floorNum: 5,  JumpAddress: audioInfo?.moreUrl}, 'DF_exposureEvent');
        }
        setMoreUrl(audioInfo?.moreUrl);
    }, [audioInfo]);

     /*** 曝光的代码 */

  useEffect(() => {
    if (firstLoad && list?.length > 0) {
      clearGioStatus();
      setDataGioList(list);
      dataList.current = list;
      const $dom = document.getElementById('AudioAndVideo');
      if (list?.length > 0 && $dom) {
        checkExposureGio(dataList.current);
        setFirstLoad(false);
      }
    }
  }, [list]);

  const gioExposure = () => {
   checkExposureGio(dataList.current);
  };

  useEffect(() => {
    const element = document.getElementById('pullToRefresh');
    element?.addEventListener('scroll', gioExposure);
    return () => {
      element?.removeEventListener('scroll', gioExposure);
    };
  }, [list]);

  useEffect(() => {
    const handleTouchStart = (event) => {
      const touch = event.touches[0];
      const startX = touch.pageX;
      sliderRef?.current?.addEventListener('touchmove', (event) => {
        gioExposure();
      });
    };
    sliderRef?.current?.addEventListener('touchstart', handleTouchStart);
    return () => {
      sliderRef?.current?.removeEventListener('touchstart', handleTouchStart);
    };
  }, [list]);

    return list?.length > 0 ? <div className={styles.meideaContent} id="AudioAndVideo" ref={sliderRef}>
      <div className={styles.titleContent}>
        <div className={styles.left}>追剧自由</div>
        {moreUrl && <div className={styles.right} onClick={() => {
            gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '直充会员', elementname: '更多会员', floorNum: 5,  JumpAddress: moreUrl});
            window.df_sdk_common.location.href = moreUrl;
        }}
                    >
          更多会员
          <img src={rightIcon}></img>
        </div>}
      </div>
      <div className="scrollContainer">
        <ul className={styles.list}>
          {list?.map((item, idx) => (
            <li key={idx} id={`audioItem${idx}`} className={styles.item}  onClick={() => {
                gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '直充会员', elementname: '直充会员', floorNum: 5, HPbanenrNum: idx+1, JumpAddress: item?.url, contentTitle: item?.brandName, content: item?.discountTag});
                if(item?.url) {
                    window.df_sdk_common.location.href = item?.url;
                }
            }}
            >
              <div className={styles.iconConetnt}>
                <DFImage src={item?.icon} key={item.id}></DFImage>
                {item?.discountTag && <div className={styles.brandDiscount}>{item?.discountTag}</div>}
              </div>
              <div className={styles.text}>{item?.brandName}</div>
            </li>
                ))}
        </ul>
      </div>
    </div> : null;
};

export default AudioAndVideo;